import { render, staticRenderFns } from "./EditChannelContainer.vue?vue&type=template&id=4cbfeb1b"
import script from "./EditChannelContainer.vue?vue&type=script&lang=js"
export * from "./EditChannelContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports